<template>
	<div :class="shown ? 'battery-notification show' : 'battery-notification'">
		<div>
			<div class="text-ct">
				<div class="icon-ct"></div>
				<span>
					<h2>{{$t('battery_notification_upper_header')}}</h2>
					<h3>{{$t('battery_notification_lower_header_part1')}}</h3>
					<h3>{{$t('battery_notification_lower_header_part2')}}</h3>
					<h3>{{$t('battery_notification_lower_header_part3')}}</h3>
				</span>
			</div>
		</div>
	</div>



</template>
<script>
export default {
    props: [
        "shown"
    ]
}
</script>